import ReportCard from "components/ReportCard";
import { useStyles } from "./DowntimeFailureCodeByMachineCenterReportCard.styles";
import SummaryReportPopover from "./SummaryReportPopover";
import DowntimeFailureCodeByMachineCenter from "./DowntimeFailureCodeByMachineCenter/DowntimeFailureCodeByMachineCenter";
import { useTranslation } from "react-i18next";
import { useContext, useMemo } from "react";
import { SummaryReportDashboardContext } from "contexts/SummaryReportDashboardContext/SummaryReportDashboardContext";
import { IMillReportCardProps } from "../../../MillDashboardInterfaces";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { DefaultTranslationFieldsInTable } from "constants/constants";

const DowntimeFailureCodeByMachineCenterReportCard = ({ countryCode }: IMillReportCardProps) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const { selectedFailureCode, selectedDowntimeBar } = useContext(SummaryReportDashboardContext);
    const openSummaryReportPopup = useMemo(() => Boolean(selectedDowntimeBar), [selectedDowntimeBar]);

    const defaultFailureCodeTranslatedName = translateDefaultEntity(
        i18n.language,
        selectedFailureCode,
        "name",
        DefaultTranslationFieldsInTable.FAILURE_CODE,
    );

    return (
        <ReportCard
            className={classes.mainWrapper}
            title={t(
                !selectedFailureCode
                    ? "locations.summary_report_dashboard.downtime_failure_code_by_machine_center.title_no_selected"
                    : "locations.summary_report_dashboard.downtime_failure_code_by_machine_center.title",
                {
                    failureCode: defaultFailureCodeTranslatedName,
                },
            )}
            noDataTitle={t("locations.summary_report_dashboard.downtime_failure_code_by_machine_center.no_data")}
            showNoData={!selectedFailureCode}
        >
            <>
                <DowntimeFailureCodeByMachineCenter countryCode={countryCode} />
                {openSummaryReportPopup && <SummaryReportPopover countryCode={countryCode} />}
            </>
        </ReportCard>
    );
};

export default DowntimeFailureCodeByMachineCenterReportCard;
